import { createContext, useContext, type ReactNode } from 'react'

interface LogoContextType {
  msb?: string
  msbLogo?: string
  msbLogoLoading?: string
}

const LogoContext = createContext<LogoContextType | undefined>(undefined)

interface LogoProviderProps {
  children: ReactNode
  msb?: string
  msbLogo?: string
  msbLogoLoading?: string
}

export function LogoProvider({ children, msb, msbLogo, msbLogoLoading }: LogoProviderProps) {
  return (
    <LogoContext.Provider value={{ msb, msbLogo, msbLogoLoading }}>{children}</LogoContext.Provider>
  )
}

export function useLogo() {
  const context = useContext(LogoContext)
  if (context === undefined) {
    throw new Error('useLogo must be used within a LogoProvider')
  }
  return context
}
